import { render } from "./UserProfile.vue?vue&type=template&id=2c0c0f42&ts=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__